import { apiService } from './ApiService';
import { AxiosResponse } from 'axios';

export interface UserProfile {
    name?: string;
    middle_name?: string;
    last_name?: string;
    email?: string;
    picture?: string;
}

export class UserService {
    private static instance: UserService;

    public static getInstance(): UserService {
        if (!UserService.instance) {
            UserService.instance = new UserService();
        }
        return UserService.instance;
    }

    public async getUserProfile(): Promise<AxiosResponse<any>> {
        return apiService.get('/api/user/profile');
    }

    public async updateUserProfile(profileData: UserProfile): Promise<AxiosResponse<any>> {
        return apiService.put('/api/user/profile', profileData);
    }
}

export const userService = UserService.getInstance();
